import { getCampaign } from '../../../../services/adv'
import { getPeriodLivePPCAuctions } from '../../../../services/micro'
import { getPublisher } from '../../../../services/pub'

export const fetchCampaignData = async (isIframe, isTokenVerified, campaignId, token) => {
    try {
        let res
        if (isIframe && isTokenVerified) {
            res = await getCampaign(campaignId, token)
        } else if (!isIframe) {
            res = await getCampaign(campaignId)
        }

        return { data: res.data, table: res.table }
    } catch (error) {
        return null
    }
}

export const getAnyPPCAuctions = async campaignId => {
    const response = await getPeriodLivePPCAuctions({ search: '' }, campaignId)

    if (!response || !response.success || !response.data || !response.data.rows || !response.data.rows.length) {
        return false
    }

    const rows = response.data.rows

    const livePPC = rows.filter(auction => auction[8]?.toString().toLowerCase() === 'live')

    return { anyAuctions: rows, liveAuctions: livePPC }
}
